__turbopack_context__.v({
  "title": "page-title-module__Do8Tpq__title",
  "truncate": "page-title-module__Do8Tpq__truncate",
});
